
export const forms = {
  'form.farmName': 'Farm Name',
  'form.yearEstablished': 'Year Established',
  'form.carbonScore': 'Carbon Score',
  'form.irrigationMethod': 'Irrigation Method',
  'form.certifications': 'Certifications',
  'form.staff': 'Staff',
  'form.revenue': 'Revenue',
  'form.pastSubsidies': 'Past Subsidies',
  'form.address': 'Address',
  'form.registrationNumber': 'Registration Number',
  'form.certificationStatus': 'Certification Status',
  'form.description': 'Description',
  'form.tooltip.carbonScore': 'Environmental impact score based on farming practices',
  'form.tooltip.irrigationMethod': 'Method used for crop irrigation',
  'form.tooltip.certifications': 'Agricultural certifications held by the farm',
  'form.tooltip.region': 'Geographic region where the farm operates',
  'form.tooltip.size': 'Total area of the farm in hectares',
  'addFarm.manualEntry': 'Manual Entry',
  'addFarm.documentUpload': 'Document Upload',
  'addFarm.frenchRegistry': 'French Registry',
  'addFarm.chooseMethods': 'Choose one of the methods below to add a new farm',
  'addFarm.selectIdType': 'Select ID Type',
  'addFarm.invalidFormat': 'Invalid {{idType}} format',
  'addFarm.searching': 'Searching...',
  'addFarm.resultFound': 'Farm Found',
  'addFarm.importButton': 'Import Farm',
  'addFarm.noMatch': 'No matching farm found',
  'addFarm.tryDifferentId': 'Please try a different ID or use manual entry',
  'addFarm.farmImported': 'Farm imported successfully',
  'addFarm.farmImportedDesc': 'The farm has been added to your portfolio',
  'addFarm.enterFarmName': 'Enter farm name',
  'addFarm.enterRegion': 'Enter region',
  'addFarm.tagsLabel': 'Tags',
  'addFarm.tagsPlaceholder': 'Add tags separated by commas',
  'addFarm.dragAndDrop': 'Drag and drop files here',
  'addFarm.supportedDocuments': 'Supported formats: PDF, DOC, DOCX',
  'addFarm.selectFiles': 'Select Files',
  'addFarm.number': 'Number',
  'addFarm.enterValid': 'Enter valid',
  'addFarm.registryHelp': 'Use test ID: 88234567890123 (SIRET) or 123456789 (SIREN/PACAGE)',
  'addFarm.searchFarm': 'Search Farm',
  'addFarm.registryId': 'Registry ID',
  'addFarm.startFarmCreation': 'Start Farm Creation',
  'forms.generateForm': 'Generate Form',
  'forms.applyNow': 'Apply Now',
  'forms.estimatedTime': 'Estimated Time',
  'forms.sections': 'Sections',
  'forms.requiredDocuments': 'Required Documents',
  'forms.formProgress': 'Form Progress',
  'forms.autoFilled': 'Auto-filled',
  'forms.saveDraft': 'Save Draft',
  'forms.submitApplication': 'Submit Application',
  'forms.previous': 'Previous',
  'forms.next': 'Next',
  'forms.originalForm': 'Original Form',
  'forms.processedView': 'Processed View',
  'forms.needHelp': 'Need Help?',
  'forms.getHelp': 'Get Help',
  'forms.required': 'Required',
  'forms.saving': 'Saving...',
  'forms.submitting': 'Submitting...',

  // Farm Form Placeholders
  'forms.placeholders.enterFarmName': 'Enter your farm or business name',
  'forms.placeholders.enterFarmAddress': 'Enter complete farm address including street, city, postal code',
  'forms.placeholders.enterAddress': 'Enter complete farm address including street, city, postal code',
  'forms.placeholders.selectLegalEntityType': 'Select legal entity type',
  'forms.placeholders.enterTaxId': 'CNP (individuals) or CUI/VAT number (companies)',
  'forms.placeholders.enterSiret': 'CNP (individuals) or CUI/VAT number (companies)',
  'forms.placeholders.selectCountry': 'Select country',
  'forms.placeholders.selectCountryFirst': 'Select country first',
  'forms.placeholders.selectDepartment': 'Select department',
  'forms.placeholders.enterCity': 'Enter city or municipality name',
  'forms.placeholders.enterMobileNumber': 'Enter mobile number with country code',
  'forms.placeholders.enterPhone': 'Enter mobile number with country code',
  'forms.placeholders.selectLanguage': 'Select language',
  'forms.placeholders.selectOwnershipType': 'Select ownership type',
  'forms.placeholders.enterArea': 'Enter area',
  'forms.placeholders.specifyOtherActivities': 'Please specify other agricultural activities',
  'forms.placeholders.selectIrrigationMethod': 'Select irrigation method',
  'forms.placeholders.enterNumberOfWorkers': 'Enter number of workers',
  'forms.placeholders.enterWorkers': 'Enter number of workers',
  'forms.placeholders.quantity': 'Quantity',
  'forms.placeholders.enterQuantity': 'Quantity',
  'forms.placeholders.specifyTypeAndQuantity': 'Specify type and quantity',
  'forms.placeholders.specifyOtherSubsidy': 'Specify any other subsidy or support interests not listed above',
  'forms.placeholders.specifyOtherInterests': 'Specify any other subsidy or support interests not listed above',
  'forms.placeholders.selectRevenueRange': 'Select revenue range',

  // Subsidy Tracking Detail Sidebar
  'forms.placeholders.exampleAmount': 'e.g., 50000',
  'forms.placeholders.exampleContactName': 'e.g., Marie Dupont',
  'forms.placeholders.exampleEmail': 'email@example.com',
  'forms.placeholders.examplePhone': '+33 1 23 45 67 89',
  'forms.placeholders.addNotesQuestionsReminders': 'Add your notes, questions, or reminders...',
  'forms.placeholders.exampleReferenceNumber': 'e.g., SUBV-2025-1234',
  'forms.placeholders.exampleSubmissionMethod': 'e.g., Online portal, Email, Mail',

  // Category Management Modal
  'forms.placeholders.exampleCategoryName': 'e.g., VIP Clients, Under Negotiation...',

  // Prime/Energy Application Form Placeholders
  'forms.placeholders.exampleNumber': 'Ex: 250',
  'forms.placeholders.exampleSmallNumber': 'Ex: 4',
  'forms.placeholders.exampleMediumNumber': 'Ex: 100',
  'forms.placeholders.exampleLargeNumber': 'Ex: 15000',
  'forms.placeholders.exampleYear': 'Ex: 1990',
  'forms.placeholders.exampleIncome': 'Ex: 25000',
  'forms.placeholders.exampleDepartmentCodes': 'Ex: 75, 13, 69',
  'forms.placeholders.exampleArea80': 'Ex: 80',
  'forms.placeholders.exampleArea60': 'Ex: 60',
  'forms.placeholders.exampleArea50': 'Ex: 50',
  'forms.placeholders.exampleArea8': 'Ex: 8',
  'forms.placeholders.exampleArea300': 'Ex: 300',
  'forms.placeholders.exampleAge12': 'Ex: 12',
  'forms.placeholders.exampleAge10': 'Ex: 10',
  'forms.placeholders.exampleAge20': 'Ex: 20',
  'forms.placeholders.addNotesOrExplanations': 'Add any additional notes or explanations...',

  // Simulation Form Placeholders
  'forms.placeholders.selectProjectType': 'Select project type',
  'forms.placeholders.enterTotalProjectCost': 'Enter total project cost',
  'forms.placeholders.enterProjectDuration': 'Enter project duration',
  'forms.placeholders.describeYourProject': 'Describe your project...',
  'forms.placeholders.zero': '0',

  // Company Edit Modals Placeholders
  'forms.placeholders.companyLegalName': 'Company legal name',
  'forms.placeholders.selectLegalForm': 'Select legal form',
  'forms.placeholders.selectEmployeeRange': 'Select employee range',
  'forms.placeholders.sirenNumber': '9-digit SIREN number',
  'forms.placeholders.siretNumber': '14-digit SIRET number',
  'forms.placeholders.searchNafCode': 'Search and select your NAF code...',
  'forms.placeholders.enterBusinessSectors': 'Enter business sectors, separated by commas',
  'forms.placeholders.firstName': 'First name(s)',
  'forms.placeholders.lastName': 'Last name',
  'forms.placeholders.selectPosition': 'Select position',
  'forms.placeholders.nationality': 'Nationality',
  'forms.placeholders.city': 'City',
  'forms.placeholders.postalCode': 'Postal code',
  'forms.placeholders.fullAddress': 'Full address',
  'forms.placeholders.siret14Digit': '14-digit SIRET',
  'forms.placeholders.nafCode': 'NAF code',
  'forms.placeholders.enterBusinessActivities': 'Enter each business activity on a new line',
  'forms.placeholders.enterInnovationIndicators': 'Enter innovation indicators on separate lines',
  'forms.placeholders.enterSustainabilityInitiatives': 'Enter sustainability initiatives on separate lines',
  'forms.placeholders.enterExportMarkets': 'Enter export markets, separated by commas',

  // Document Upload Placeholders
  'forms.placeholders.documentNameExample': 'e.g., Business Registration Certificate',
  'forms.placeholders.selectDocumentType': 'Select document type',
  'forms.placeholders.documentAdditionalInfo': 'Additional information about this document...',

  // Security Audit Log Placeholders
  'forms.placeholders.filterByUserId': 'Filter by user ID',
  'forms.placeholders.eventType': 'Event type',
  'forms.placeholders.riskLevel': 'Risk level',

  // New placeholder keys for modals and components
  'forms.placeholders.enterYourEmail': 'your.email@example.com',
  'forms.placeholders.searchProfile': 'Search for a profile...',
  'forms.placeholders.searchClients': 'Search clients...',
  'forms.placeholders.colleagueEmail': 'colleague@company.com',
  'forms.placeholders.chooseSubsidy': 'Choose a subsidy...',
  'forms.placeholders.addSubsidyNotes': 'Add any notes about this subsidy...',
  'forms.placeholders.enterCorrectValue': 'Enter the correct value if you know it',
  'forms.placeholders.describeWrong': 'Describe what\'s wrong or provide additional context...',
  'forms.placeholders.searchByNameOrNumber': 'Search by name or number (e.g., commerce, 47, restaurant...)',
  'forms.placeholders.searchPotentialSubsidies': 'Search potential subsidies...',
  'forms.placeholders.searchSubsidies': 'Search subsidies...',
  'forms.placeholders.searchSectors': 'Search sectors...',
  'forms.placeholders.typeProfileName': 'Type profile name to confirm',
  'forms.placeholders.emailExample': 'name@example.com',
  'forms.placeholders.addEmailsAbove': 'Add emails above to invite members',
} as const;
